/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Tut_Meja_S1Inputs */

const en_tut_meja_s1 = /** @type {(inputs: Tut_Meja_S1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Claim a desk with **Pakai meja**, then press **Percakapan meja** on it.`)
};

const id_tut_meja_s1 = /** @type {(inputs: Tut_Meja_S1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Klaim sebuah meja dengan **Pakai meja**, lalu tekan **Percakapan meja** pada meja itu.`)
};

/**
* | output |
* | --- |
* | "Claim a desk with **Pakai meja**, then press **Percakapan meja** on it." |
*
* @param {Tut_Meja_S1Inputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const tut_meja_s1 = /** @type {((inputs?: Tut_Meja_S1Inputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Tut_Meja_S1Inputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_tut_meja_s1(inputs)
	return en_tut_meja_s1(inputs)
});